// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import type ControlIcons from './ControlIcons';

export type ControlIconsSubset = { [icon in ControlIcons]: string };

export let ControlIconsDefinitions: ControlIconsSubset = {
    Accept: '\ue8fb',
    AccessibiltyChecker: '\uf835',
    Accounts: '\ue910',
    Add: '\ue710',
    AddEvent: '\ueeb5',
    AddFriend: '\ue8fa',
    AddReaction: '\uf85d',
    Airplane: '\ue709',
    AirplaneSolid: '\ueb4c',
    AlarmClock: '\ue919',
    AlertSolid: '\uf331',
    AlignLeft: '\ue8e4',
    AlignRight: '\ue8e2',
    AllApps: '\ue71d',
    AnalyticsLogo: '\uf1de',
    Archive: '\uf03f',
    Arrivals: '\ueb34',
    Ascending: '\uedc0',
    Assign: '\ue9d3',
    Attach: '\ue723',
    AutoEnhanceOn: '\ue78d',
    Back: '\ue72b',
    BingLogo: '\ueb6b',
    BlockContact: '\ue8f8',
    Blocked: '\ue733',
    BookingsLogo: '\uedc7',
    BoxLogo: '\ued75',
    BulletedList: '\ue8fd',
    Bullseye: '\uf272',
    Calendar: '\ue787',
    CalendarReply: '\ue8f5',
    CalendarSettings: '\uf558',
    Camera: '\ue722',
    Cancel: '\ue711',
    Car: '\ue804',
    CaretLeftSolid8: '\uedd9',
    CaretRightSolid8: '\uedda',
    CellPhone: '\ue8ea',
    Chat: '\ue901',
    ChatInviteFriend: '\uecfe',
    Checkbox: '\ue739',
    CheckboxComposite: '\ue73a',
    CheckMark: '\ue73e',
    ChevronDown: '\ue70d',
    ChevronDownMed: '\ue972',
    ChevronLeft: '\ue76b',
    ChevronLeftMed: '\ue973',
    ChevronRight: '\ue76c',
    ChevronRightMed: '\ue974',
    ChevronUp: '\ue70e',
    ChromeClose: '\ue8bb',
    ChromeMinimize: '\ue921',
    CircleAddition: '\uf2e3',
    CircleAdditionSolid: '\uf2e4',
    CircleFill: '\uea3b',
    CirclePlus: '\ueaee',
    CircleRing: '\uea3a',
    CityNext: '\uec06',
    Clear: '\ue894',
    ClearFilter: '\uef8f',
    ClearNight: '\ue9c2',
    ClearSelection: '\ue8e6',
    ClipboardList: '\uf0e3',
    Clock: '\ue917',
    ClosePane: '\ue89f',
    Cloud: '\ue753',
    CloudAdd: '\ueca9',
    CloudDownload: '\uebd3',
    CloudEdit: '\ue4c8',
    CloudLink: '\ue4c9',
    CloudUpload: '\uec8e',
    CodeEdit: '\uf544',
    CollapseContent: '\uf165',
    Color: '\ue790',
    CommentUrgent: '\uf307',
    Completed: '\ue930',
    CompletedSolid: '\uec61',
    Contact: '\ue77b',
    ContactCard: '\ueebd',
    ContactList: '\uf7e5',
    ContactLock: '\uf400',
    Copy: '\ue8c8',
    CustomizeToolbar: '\uf828',
    DateTime: '\uec92',
    DeclineCall: '\uf405',
    Delete: '\ue74d',
    DeliveryTruck: '\uebf4',
    Descending: '\uedc1',
    DeveloperTools: '\uec7a',
    Diamond: '\ued02',
    Dislike: '\ue8e0',
    DocumentSearch: '\uef6c',
    Door: '\ueb75',
    DoubleChevronDown: '\uee04',
    DoubleChevronLeft: '\uedbe',
    DoubleChevronRight: '\uedbf',
    DoubleChevronUp: '\uedbd',
    Down: '\ue74b',
    Download: '\ue896',
    Drop: '\ueb42',
    DropboxLogo: '\ued77',
    EaseOfAccess: '\ue776',
    EatDrink: '\ue807',
    Edit: '\ue70f',
    Education: '\ue7be',
    EgnyteLogo: '\uf373',
    Embed: '\uecce',
    EMI: '\ue731',
    Emoji: '\ue899',
    Emoji2: '\ue76e',
    EmojiTabSymbols: '\ued58',
    Encryption: '\uf69d',
    EndPointSolid: '\ueb4b',
    Equalizer: '\ue9e9',
    Error: '\ue783',
    ErrorBadge: '\uea39',
    Event: '\ueca3',
    EventAccepted: '\uf422',
    EventDeclined: '\uf425',
    EventInfo: '\ued8b',
    EventTentative: '\uf423',
    EventToDoLogo: '\uf869',
    ExploreContent: '\ueccd',
    FabricFolder: '\uf0a9',
    FabricMovetoFolder: '\uf0a5',
    FabricNewFolder: '\uf0ab',
    FacebookLogo: '\uecb3',
    Family: '\uebda',
    FangBody: '\ueceb',
    FavoriteList: '\ue728',
    FavoriteStar: '\ue734',
    FavoriteStarFill: '\ue735',
    Feedback: '\ued15',
    FileTemplate: '\uf2e6',
    Filter: '\ue71c',
    Flag: '\ue7c1',
    Flashlight: '\ue754',
    Flow: '\uef90',
    FluidLogo: '\ue48a',
    Folder: '\ue8b7',
    FolderHorizontal: '\uf12b',
    Forward: '\ue72a',
    ForwardEvent: '\ued8c',
    Frigid: '\ue9ca',
    FullScreen: '\ue740',
    FullView: '\uf1a2',
    GIF: '\uf4a9',
    GiftCard: '\ueb8e',
    GlobalNavButton: '\ue700',
    Globe: '\ue774',
    Globe2: '\uf49a',
    GoogleDriveLogo: '\uee0b',
    GotoToday: '\ue8d1',
    GripperDotsVertical: '\uf772',
    Group: '\ue902',
    Heart: '\ueb51',
    HeartBroken: '\uea92',
    HeartFill: '\ueb52',
    Help: '\ue897',
    Hide: '\ued1a',
    Hide3: '\uf6ac',
    History: '\ue81c',
    Home: '\ue80f',
    Hotel: '\ue824',
    Important: '\ue8c9',
    Inbox: '\uf41c',
    Info: '\ue946',
    InsertSignatureLine: '\uf677',
    InsertTextBox: '\uec7d',
    Insights: '\ue3af',
    Label: '\ue932',
    LargeGrid: '\ueecb',
    Lightbulb: '\uea80',
    LightningBolt: '\ue945',
    Like: '\ue8e1',
    Link: '\ue71b',
    Link12: '\uf6e3',
    LinkedInLogo: '\uf20a',
    List: '\uea37',
    LocaleLanguage: '\uf2b7',
    Location: '\ue81d',
    LocationDot: '\ue827',
    Lock: '\ue72e',
    Mail: '\ue715',
    MailAlert: '\ued80',
    MailAttached: '\uf774',
    MailCheck: '\ued81',
    MailForward: '\ue89c',
    MailOptions: '\uf82c',
    MailPause: '\ued83',
    MailSecure: '\ue4d4',
    MailSolid: '\uf343',
    MailUndelivered: '\uf415',
    MapDirections: '\ue816',
    MapPin: '\ue707',
    MarkAsProtected: '\uf6ae',
    Megaphone: '\ue789',
    MicrosoftTranslatorLogo: '\uf782',
    MiniExpand: '\ue93a',
    MiniExpandMirrored: '\uea5a',
    MobileSelected: '\uec75',
    Money: '\ueafd',
    More: '\ue712',
    MoreVertical: '\uf2bc',
    MSNVideos: '\ueb1c',
    NavigateExternalInline: '\uf35f',
    NewMail: '\uf7ea',
    NotePinned: '\ued9a',
    NumberField: '\uedc4',
    NumberSymbol: '\uf7ac',
    OfficeChat: '\uf70f',
    OneDriveFileVault: '\uf838',
    OneDriveLogo: '\ue941',
    OneNoteLogo: '\uf1e7',
    OpenInNewTab: '\uf6ab',
    OpenInNewWindow: '\ue8a7',
    OpenPane: '\ue8a0',
    OpenSource: '\uebc2',
    Org: '\ueca6',
    OutlookLogo: '\uf1e9',
    OutlookLogoInverse: '\ueb6d',
    OutlookSpacesBucket: '\ue481',
    Package: '\ue7b8',
    Page: '\ue7c3',
    PageEdit: '\uefb6',
    PageLink: '\ue302',
    PageRemove: '\uefba',
    ParkingLocation: '\ue811',
    ParkingLocationMirrored: '\uea5e',
    PartlyCloudyDay: '\ue9c0',
    Paste: '\ue77f',
    PasteAsText: '\uf5d5',
    PaymentCard: '\ue8c7',
    PDF: '\uea90',
    PencilReply: '\uef7b',
    People: '\ue716',
    PeopleAdd: '\uea15',
    PeopleAlert: '\ued93',
    Personalize: '\ue771',
    Phone: '\ue717',
    Photo2: '\ueb9f',
    PieSingle: '\ueb05',
    Pinned: '\ue840',
    PinnedSolid: '\uf676',
    PlainText: '\uf834',
    Play: '\ue768',
    POI: '\uecaf',
    PreviewLink: '\ue8a1',
    Print: '\ue749',
    Puzzle: '\uea86',
    QuickNote: '\ue70b',
    Read: '\ue8c3',
    Recent: '\ue823',
    RectangularClipping: '\uf407',
    RedEye: '\ue7b3',
    Refresh: '\ue72c',
    RemoveContent: '\uecc7',
    RemoveEvent: '\ued8a',
    RemoveFromTrash: '\uf82b',
    RemoveLink: '\ued90',
    Rename: '\ue8ac',
    ReopenPages: '\ued50',
    Reply: '\ue97a',
    ReplyAll: '\uee0a',
    ReportHacked: '\ue730',
    Ribbon: '\ue9d1',
    RightDoubleQuote: '\ue9b1',
    Ringer: '\uea8f',
    RingerOff: '\uf2c5',
    Rotate: '\ue7ad',
    Sad: '\ue757',
    Save: '\ue74e',
    ScheduleEventAction: '\uf1ef',
    ScrollUpDown: '\uec8f',
    Search: '\ue721',
    SearchCalendar: '\uf4af',
    Send: '\ue724',
    Settings: '\ue713',
    Share: '\ue72d',
    SharedNotes: '\uf481',
    ShowTimeAs: '\uf787',
    SkypeForBusinessLogo: '\uf0fc',
    SkypeForBusinessLogo16: '\uf40f',
    SkypeLogo: '\ueb6f',
    SkypeLogo16: '\uf40e',
    Soccer: '\ueb21',
    Sort: '\ue8cb',
    SortDown: '\uee69',
    SortLines: '\ue9d0',
    SortUp: '\uee68',
    SpecialEvent: '\uf536',
    SquareShapeSolid: '\uf63d',
    Stack: '\uf26f',
    StatusCircleCheckmark: '\uf13e',
    StatusCircleErrorX: '\uf13d',
    StatusCircleQuestionMark: '\uf142',
    Stopwatch: '\ue916',
    Sunny: '\ue9bd',
    SyncOccurence: '\uf4a3',
    SyncToPC: '\uee6e',
    System: '\ue770',
    Tab: '\ue7e9',
    TabCenter: '\uf100',
    Table: '\ued86',
    Tag: '\ue8ec',
    TagSolid: '\uf70e',
    Taskboard: '\uf1c2',
    TeamsLogo: '\uf27b',
    Telemarketer: '\ue7b9',
    TextDocumentSettings: '\ue4aa',
    TextDocumentShared: '\uf02b',
    Ticket: '\ueb54',
    Tiles: '\ueca5',
    ToDoLogoOutline: '\uf75b',
    TVMonitor: '\ue7f4',
    Undo: '\ue7a7',
    Unknown: '\ue9ce',
    Unlock: '\ue785',
    UnsyncOccurence: '\uf4a4',
    Up: '\ue74a',
    Upload: '\ue898',
    Video: '\ue714',
    View: '\ue890',
    ViewAll: '\ue8a9',
    Volume2: '\ue994',
    Waffle: '\ued89',
    Warning: '\ue7ba',
    WebPublish: '\uf52f',
    WipePhone: '\ued8d',
    World: '\ue909',
    WorldClock: '\ue918',
    YammerLogo: '\ued19',
    ZoomIn: '\ue8a3',
    ZoomOut: '\ue71f',
};

export default {
    fontFileName: 'controlIcons',
    icons: ControlIconsDefinitions,
};
